import { Component, OnInit } from '@angular/core';
import { NeoTrackEventAction, NeoTrackEventComponent, NeoTrackEventLocation, NeoTrackEventStatus } from '@app/services/amplitude.service.models';
import { NeoBaseComponent } from '@app/shared/components/base/neo-base.component';

@Component({
    selector: 'neo-failed',
    templateUrl: './failed.component.html',
    styleUrls: ['./failed.component.scss'],
    standalone: false
})
export class FailedComponent  extends NeoBaseComponent implements OnInit {
  constructor() {
    super();
  }

  public ngOnInit(): void {
    this.amplitudeService.track(NeoTrackEventAction.View, NeoTrackEventComponent.App, NeoTrackEventLocation.PageFailed, NeoTrackEventStatus.None);
    this.neoLogService.log('Failed Component');
  }

}
